import { request } from '../utils/ajax'
import {
  REQUEST_BASE_URL,
  GET_GAME_INFO,
  GET_ARTICLE_LIST,
  GET_ARTICLE_DETAIL,
  GET_SLIDE_LIST,
  SET_GAME_INFO
} from './config'

const GET_ARTICLE_LIST_ACTION = REQUEST_BASE_URL + 'article_list'
const GET_GAME_INFO_ACTION = REQUEST_BASE_URL + 'get_game_info'
const GET_ARTICLE_DETAIL_ACTION = REQUEST_BASE_URL + 'article_content'
const GET_SLIDE_LIST_ACTION = REQUEST_BASE_URL + 'article_slide_list'

const actions = {
  [GET_GAME_INFO] ({ commit, dispatch }, gameId) {
    return new Promise((resolve) => {
      request(GET_GAME_INFO_ACTION, { gameID: gameId })
        .then(({ errmsg, data }) => {
          if (!errmsg) {
            commit(SET_GAME_INFO, data)
            resolve(data)
          } else {
            resolve(false)
          }
        })
    })
  },
  [GET_ARTICLE_LIST] ({ commit, dispatch }, article) {
    let params = {
      gameID: article.gameId,
      ids: article.type,
      orderBy: article.orderBy || 'PUBLISH_TIME',
      orderWay: article.orderWay || 'DESC',
      page: article.page || 1,
      num: article.num || 5
    }
    return new Promise((resolve) => {
      request(GET_ARTICLE_LIST_ACTION, params)
        .then(({ errmsg, data }) => {
          if (!errmsg) {
            resolve(data)
          } else {
            resolve(false)
          }
        })
    })
  },
  [GET_ARTICLE_DETAIL] ({ commit, dispatch }, id) {
    return new Promise((resolve) => {
      request(GET_ARTICLE_DETAIL_ACTION, { id: id })
        .then(({ errmsg, data }) => {
          if (!errmsg) {
            resolve(data)
          } else {
            resolve(false)
          }
        })
    })
  },
  [GET_SLIDE_LIST] ({ commit, dispatch }, slide) {
    let params = {
      gameID: slide.gameId,
      site: slide.site || 'head'
    }
    return new Promise((resolve) => {
      request(GET_SLIDE_LIST_ACTION, params)
        .then(({ errmsg, data }) => {
          if (!errmsg) {
            resolve(data)
          } else {
            resolve(false)
          }
        })
    })
  }
}

export default actions
